import { variant } from "styled-system";
import { WHCM } from "../constants";

export const focus = {
  boxShadow: "focus",
  outline: "none",

  [WHCM]: {
    outline: "auto",
  },
};

export const linkFocus = {
  outlineStyle: "solid",
  outlineWidth: "3px",
  outlineOffset: "1px",
  outlineColor: "#6688DD",
  borderRadius: "4px",
  outlineRadius: "4px",
};

const focusable = variant({
  prop: "focusable",
  variants: {
    focusable: {
      "&:focus": focus,
    },
    focusableWithin: {
      "&:focus-within": focus,
    },
  },
});

export default focusable;
